import React from 'react';
import { instanceOf, number, string } from 'prop-types';
import moment from 'moment';
import { useFormik } from 'formik';

import DateField from '../../components/FormFields/DateField';

const TimestampFilter = ({
    dateFormat,
    endTimestamp,
    onFilterChange,
    showTimeSelect,
    startTimestamp,
    timeFormat,
    timeIntervals
}) => {
    const { errors, touched, values, ...form } = useFormik({
        enableReinitialize: true,
        initialTouched:     {
            endTimestamp:   true,
            startTimestamp: true
        },
        initialValues: {
            endTimestamp:   endTimestamp,
            startTimestamp: startTimestamp
        },
        validateOnBlur: false
    });

    /**
     * Modifies the appropriate timestamp value based on the value of the
     * changed requisite date or time input.
     */
    function handleChange(name) {
        return (value, event) => {
            let parsedValue = null;
            if (value) {
                parsedValue = moment(value);
                form.setFieldValue(name, parsedValue);
            }
            form.setFieldTouched(name, true);
            onFilterChange(name, parsedValue, value);
        };
    }

    return (
        <>
            <DateField
                dateFormat={dateFormat}
                isClearable
                label="Start Time"
                margin="dense"
                name="startTimestamp"
                onChange={handleChange('startTimestamp')}
                showTimeSelect={showTimeSelect}
                timeFormat={timeFormat}
                timeIntervals={timeIntervals}
                value={values.startTimestamp.toDate()}
            />
            <DateField
                disabled={true}
                dateFormat={dateFormat}
                errors={errors.endTimestamp}
                isClearable
                label="End Time"
                margin="dense"
                name="endTimestamp"
                onChange={handleChange('endTimestamp')}
                showTimeSelect={showTimeSelect}
                timeFormat={timeFormat}
                timeIntervals={timeIntervals}
                touched={touched.endTimestamp}
                value={values.endTimestamp.toDate()}
            />
        </>
    );
};

TimestampFilter.defaultProps = {
    disabled:       false,
    dateFormat:     'yyyy-MM-dd h:mm a',
    showTimeSelect: true,
    timeFormat:     'h:mm a',
    timeIntervals:  15
};

TimestampFilter.propTypes = {
    dateFormat:     string,
    endTimestamp:   instanceOf(moment).isRequired,
    startTimestamp: instanceOf(moment).isRequired,
    timeFormat:     string,
    timeIntervals:  number
};

export default TimestampFilter;
